<app-loading *ngIf="loading"></app-loading>


<div class="row header azul r0">
    <div class="col-11">
       <h2 class="animate__animated animate__fadeIn"><i class="fa-regular fa-clock"></i> Sectores</h2>
    </div>
    <div class="col-1 text-right hvr-icon-bounce">
        <h2><i class="fa-solid fa-circle-question hvr-icon pointer" (click)="_m.info('Sectores', 'Los sectores existen para ordenar las mesas. Por ejemplo puedes tener mesas en el sector Terraza, o segundo piso, etc.')"></i></h2>
    </div>
</div>

<div class="row headMenu animate__animated animate__fadeIn r0">
    <div class="col-6 pad20 hvr-forward">
        <p class=" botonMenu animate__animated animate__pulse" data-bs-toggle="offcanvas" data-disableScrolling="false" href="#menuData" role="button" aria-controls="menuData"> < Menu Data </p>
    </div>
    <div class="col-5 text-end " style="padding:30px 20px 0 0 "> 
        <!-- <button *ngIf="grupos.length > 0" class="btn btn-outline-primary animate__animated animate__heartBeat animate__infinite animate__slower" routerLink="/data/producto/new">Crear Producto</button> -->
    </div>
</div> 

<div *ngIf="stores.length > 1" class="row r0">
    <div class="col-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2 opciones shadow">
        <label>Selecciona el local</label>
        <select [(ngModel)]="selectedStore" (change)="onStoreChange()"  class="form-select">
            <option *ngFor="let store of stores" [ngValue]="store">
              {{ store.name }}
            </option>
          </select>
    </div>
</div>

<div *ngIf="modalNuevo" class="row r0">
    <div class="col-10 offset-1  col-lg-8 offset-lg-2 listado shadow animate__animated animate__flipInX">
        <div class="row">
            <div class="col-11">
                <h5>Nuevo Sector</h5>
            </div>
            <div class="col-1 text-right hvr-icon-rotate cruz">
                <i class="fas fa-times hvr-icon" (click)="modalNuevo = false"></i>
            </div>
            <div class="col-12 col-md-4">
                <label>Nombre</label>
                <input type="text" class="form-control"  placeholder="Escribe aqui" [(ngModel)]="sector.name" >
            </div>

            <div class="col-12 col-md-2">
                <label>Activa</label>
                <p (click)="modifStatus()"><i [ngClass]="sector.status > 0 ? 'fa-solid fa-toggle-on icono text-success fa-2x':'fa-solid fa-toggle-off fa-2x icono text-danger' " class="mt-1"></i></p>
            </div>
        </div>
        <div class="row">
            <div class="col-9">
                <button class="btn btn-success w-100" (click)="guardar()" >Guardar</button>
            </div>
            <div class="col-2">
                <button class="btn btn-danger"  (click)="modalNuevo = false;" >Cancelar</button>
            </div>
        </div>
    </div>
</div>        

<div *ngIf="modalEdit" class="row r0">
    <div class="col-10 offset-1 col-md-10 offset-md-1 col-lg-8 offset-lg-2 listado shadow animate__animated animate__flipInX">
        <div class="row">
            <div class="col-11">
                <h5>Editar Sector</h5>
            </div>
            <div class="col-1 text-right hvr-icon-rotate cruz">
                <i class="fas fa-times hvr-icon" (click)="modalEdit = false"></i>
            </div>
            <div class="col-12 col-md-4">
                <label>Nombre</label>
                <input type="text" class="form-control"  placeholder="Escribe aqui" [(ngModel)]="sector.name" >
            </div>

            <div class="col-12 col-md-2">
                <label>Activa</label>
                <p (click)="modifStatus()"><i [ngClass]="sector.status > 0 ? 'fa-solid fa-toggle-on icono text-success fa-2x':'fa-solid fa-toggle-off fa-2x icono text-danger' " class="mt-1"></i></p>
            </div>
        </div>
        <div class="row">
            <div class="col-9">
                <button class="btn btn-success w-100" (click)="guardar()">Guardar</button>
            </div>
            <div class="col-2 text-center">
                <button class="btn btn-danger" (click)="cancelar()">Cancelar</button>
            </div>
        </div>
    </div>
</div>        


<div class="row r0">
    <div class="col-10 offset-1 col-lg-8 offset-lg-2 listado shadow">
        <table class="table table-hover" *ngIf="!loading2">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Nombre</th>
                <th scope="col">status</th>
              </tr>
            </thead>
            <tbody *ngIf="sectores.length > 0">
              <tr *ngFor="let s of sectores ; index as i " class="pointer" (click)="selectSector(s)">
                <td>{{i + 1}}</td>
                <td >{{s.name}}</td>
                <td [ngClass]="s.status > 0 ? 'text-success':'text-danger' " ><i class="fa-solid fa-circle"></i></td>
              </tr> 
            </tbody>
            <p *ngIf="sectores.length < 1">No hay Sectores para este local</p>
          </table>
          <button *ngIf="!loading2" class="btn btn-outline-primary w-100" (click)="nuevo()">Nuevo Sector</button>

          <div class="row" *ngIf="loading2">
            <div class="col-12 text-center">
                <p> Cargando <i class="fas fa-spinner fa-spin"></i></p>
            </div>
          </div>
    </div>
</div> 




<app-menu-data></app-menu-data>
